import { useCustomerFavoritesStore } from '@/stores/favorites'; // Assume you have this
import useAuth from './useAuth';
import toast from 'react-hot-toast';
import {
  addToFavorite,
  removeFromFavorite,
} from '@/clients/customer/favorites';
import { toastErrors } from '@/lib/helpers/functions';
import { useTranslations } from 'next-intl';
import { STOREFRONT } from '@/lib/utils/translation';
import { useState } from 'react';

export const useFavoriteHandler = (favoriteType: string, itemID: number) => {
  const { isCustomerLoggedIn } = useAuth();
  const t = useTranslations();
  const [isFavoriteToggleLoading, setIsFavoriteToggleLoading] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const favoriteRestaurantIDs = useCustomerFavoritesStore(
    (state) => state.favoriteRestaurantIDs
  );
  const favoriteEventIDs = useCustomerFavoritesStore(
    (state) => state.favoriteEventIDs
  );

  const favoriteJobIDs = useCustomerFavoritesStore(
    (state) => state.favoriteJobIDs
  );

  const addToFabState = useCustomerFavoritesStore(
    (state) => state.addToFavoriteState
  );
  const removeFromFabState = useCustomerFavoritesStore(
    (state) => state.removeFromFavoriteState
  );

  let isFavorite = false;

  if (favoriteType === 'restaurant') {
    isFavorite = favoriteRestaurantIDs.includes(itemID);
  } else if (favoriteType === 'event') {
    isFavorite = favoriteEventIDs.includes(itemID);
  } else if (favoriteType === 'job') {
    isFavorite = favoriteJobIDs.includes(itemID);
  }

  const redirectToLogin = () => {
    setShowLoginModal(false);
    window.location.href =
      '/login?redirect=' + encodeURIComponent(window.location.href);
  };

  const toggleFavorite = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isCustomerLoggedIn) {
      setShowLoginModal(true);
      // window.location.href =
      //   '/login?redirect=' + encodeURIComponent(window.location.href);
      return;
    }
    setIsFavoriteToggleLoading(true);
    if (isFavorite) {
      toast.loading(t(`${STOREFRONT.FAVORITES}.removing`), {
        id: 'remove-favorite',
      });
      removeFromFavorite(favoriteType, itemID)
        .then((res) => {
          if (res?.data) {
            // Update the favorite state in the store
            // mutate(['customer-favorites', locale]);
            removeFromFabState(favoriteType, itemID);
            toast.success(res?.data?.message);
          }
        })
        .catch(({ response }) => {
          toastErrors(response?.data);
        })
        .finally(() => {
          toast.dismiss('remove-favorite');
          setIsFavoriteToggleLoading(false);
        });
    } else {
      toast.loading(t(`${STOREFRONT.FAVORITES}.adding`), {
        id: 'add-favorite',
      });
      addToFavorite(favoriteType, itemID)
        .then((res) => {
          if (res?.data) {
            // Update the favorite state in the store
            // mutate(['customer-favorites', locale]);
            addToFabState(favoriteType, itemID);
            toast.success(res?.data?.message);
          }
        })
        .catch(({ response }) => {
          toastErrors(response?.data);
        })
        .finally(() => {
          toast.dismiss('add-favorite');
          setIsFavoriteToggleLoading(false);
        });
    }
  };

  return {
    toggleFavorite,
    isFavorite,
    isFavoriteToggleLoading,
    showLoginModal,
    setShowLoginModal,
    redirectToLogin,
  };
};
